import * as React from "react";
import { forwardRef } from "react";
const SvgDropLeft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m 9.9999904,7.5857854 -2.58579,-2.58582 c -0.62997,-0.6299 -1.70711,-0.1838 -1.70711,0.7071 v 5.1716096 c 0,0.8909 1.07714,1.33707 1.7071,0.70711 l 2.5858,-2.5857896 c 0.3904996,-0.39052 0.3904996,-1.02369 0,-1.41421 z", fill: "currentColor", id: "path2" }));
const ForwardRef = forwardRef(SvgDropLeft);
export default ForwardRef;
